module.exports = __webpack_public_path__ + "static/recruitment-bc6cd7b6136c1c39bcdb4d7f1702acf9.pdf";